(function () {
// Prevent double binding if included twice
if (window.DISCOUNT_SORT_BOUND) return;
window.DISCOUNT_SORT_BOUND = true;

const PARAM = 'custom_sort';
const SORTS = {
'discount-desc': { label: 'Discount % (High to Low)', dir: 'desc' },
'discount-asc': { label: 'Discount % (Low to High)', dir: 'asc' }
};

let gridObserver = null;
let isReordering = false;

function getActive() {
const v = new URLSearchParams(location.search).get(PARAM);
return SORTS[v] ? v : null;
}

function setParam(val) {
const url = new URL(location.href);
url.searchParams.set(PARAM, val);
history.replaceState({}, '', url);
}
function clearParam() {
const url = new URL(location.href);
url.searchParams.delete(PARAM);
history.replaceState({}, '', url);
}

// Use this theme’s inner grid
function findGrid() {
return (
document.getElementById('bls__product-grid') ||
document.querySelector('#product-grid .bls__grid') ||
document.querySelector('.bls__grid') ||
document.querySelector('.product-grid')
);
}

function getGridChildren(grid) {
// Only element nodes
return Array.from(grid.children).filter((n) => n.nodeType === 1);
}

// De‑dupe by product id if available to avoid any double-insertions caused by theme scripts
function dedupeByProductId(nodes) {
const seen = new Set();
const out = [];
nodes.forEach((n) => {
const pid = n.getAttribute('data-product-id') || '';
if (pid) {
if (seen.has(pid)) return; // skip duplicate
seen.add(pid);
}
out.push(n);
});
return out;
}

function updateSelectedUI(val) {
// Highlight in ALL sort lists (mobile + desktop)
document.querySelectorAll('#SortBy').forEach((ul) => {
ul.querySelectorAll('li.selected,[selected]').forEach((li) => {
li.classList.remove('selected');
li.removeAttribute('selected');
});
const target = ul.querySelector(li[value="${val}"]);
if (target) {
target.classList.add('selected');
target.setAttribute('selected', 'selected');
}
});


// Update desktop visible label
document
  .querySelectorAll('.select-custom .select-selected > span:first-child')
  .forEach((span) => { span.textContent = SORTS[val].label; });
}

// Sorter that pushes 0% (non-discounted) to the end for both asc and desc
function sortCurrentPage(val) {
const grid = findGrid();
if (!grid) return;


let children = getGridChildren(grid);
children = dedupeByProductId(children); // safety net

const productPositions = [];
const productNodes = [];

children.forEach((el, i) => {
  if (el.hasAttribute('data-discount')) {
    productPositions.push(i);
    productNodes.push(el);
  }
});
if (!productNodes.length) return;

const dir = SORTS[val].dir;
const getD = (el) => {
  const v = parseFloat(el.getAttribute('data-discount') || '0');
  return isNaN(v) ? 0 : v;
};
const isZero = (el) => getD(el) <= 0;

const sorted = productNodes.slice().sort((a, b) => {
  const az = isZero(a), bz = isZero(b);
  if (az && !bz) return 1;   // 0% after discounted items
  if (!az && bz) return -1;  // discounted before 0%
  const da = getD(a), db = getD(b);
  return dir === 'asc' ? (da - db) : (db - da);
});

// If already in the right order, skip
let already = true;
for (let i = 0; i < productNodes.length; i++) {
  if (productNodes[i] !== sorted[i]) { already = false; break; }
}
if (already) return;

isReordering = true;
if (gridObserver) gridObserver.disconnect();

// Rebuild children array with sorted product nodes placed back into original product positions
const newOrder = children.slice();
productPositions.forEach((pos, i) => { newOrder[pos] = sorted[i]; });

// Critical: replaceChildren prevents duplicates
grid.replaceChildren(...newOrder);

setTimeout(() => { isReordering = false; watchGrid(); }, 0);
}

function apply(val) {
setParam(val);
updateSelectedUI(val);
sortCurrentPage(val);
}

function bindEvents() {
// Clicks on our list items (<ul id="SortBy"><li value="...">)
document.addEventListener('click', (e) => {
const li = e.target.closest('#SortBy li[value]');
if (!li) return;

  const val = li.getAttribute('value');
  if (SORTS[val]) {
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    apply(val);
  } else {
    // Native options -> clear our flag and let theme handle
    clearParam();
  }
}, true);

// Re-apply after theme/filter updates
document.addEventListener('facet:updated', () => {
  const k = getActive();
  if (k) sortCurrentPage(k);
});
document.addEventListener('shopify:section:load', () => {
  const k = getActive();
  if (k) sortCurrentPage(k);
});
}

function watchGrid() {
const grid = findGrid();
if (!grid) return;
if (gridObserver) gridObserver.disconnect();


gridObserver = new MutationObserver((muts) => {
  const k = getActive();
  if (!k || isReordering) return;
  for (const m of muts) {
    if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
      sortCurrentPage(k);
      break;
    }
  }
});
gridObserver.observe(grid, { childList: true });
}

function init() {
bindEvents();

const k = getActive();
if (k) {
  updateSelectedUI(k);
  sortCurrentPage(k);
}

watchGrid();
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
})();